import { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { ErrorSSTStyles, errorSSTStyles } from 'inquiry/mixins/form';

const FormErrorContainer = styled.div<{ hasError: boolean; styles?: ErrorSSTStyles }>`
  ${({ styles }) => errorSSTStyles(styles)}

  // render error div always but use CSS to hide as some screen readers
  // will not announce errors if div shows up at same as message.
  // I wasn't able to repro this issue though with mac / chrome screenreaders though
  display: ${({ hasError }) => (hasError ? null : 'none')};
`;

interface FormErrorProps {
  errorMessage: string | null;
  hasError: boolean;
  styles?: ErrorSSTStyles;
}

const FormError = (props: FormErrorProps & HTMLAttributes<HTMLDivElement>) => {
  const { errorMessage, hasError, styles, ...attributes } = props;

  return (
    <FormErrorContainer
      aria-live='polite'
      role='alert'
      hasError={hasError}
      styles={styles}
      {...attributes}
    >
      {errorMessage}
    </FormErrorContainer>
  );
};

export default FormError;
